<template>
  <div class="steps-container">
    <div class="steps">
      <div class="step" v-for="step in steps" v-bind:class="{ 'active': step.active == true }">
        <div class="icon"></div>
        <span v-text="step.name"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtimizadorStep",
  props: ["steps"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="less">
@import (reference) url('../../assets/variables.less');

.steps-container {
  position: relative;
  display: block;
  margin: 0 0 45px 0;

  .steps {
    position: relative;
    display: grid;
    grid-template-columns: 33.3% 33.3% 33.3%;

    .step {
      text-align: center;
      position: relative;
      padding: 40px 0 0 0;

      &.active {

        &:after,
        &:before {
          background: @azul;
        }

        .icon {
          background: @azul;
          border-color: @azul;
        }
      }

      .icon {
        display: block;
        background: white;
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        width: 20px;
        height: 20px;
        margin: auto;
        border-radius: 100%;
        border: solid 2px gray;
      }

      &:after,
      &:before {
        content: "";
        position: absolute;
        width: 50%;
        height: 2px;
        display: block;
        background: gray;
        top: 21px;
        z-index: -1;
      }

      &:after {
        right: 0;
      }

      &:first-of-type {
        &:before {
          display: none;
        }
      }

      &:last-of-type {
        &:after {
          display: none;
        }
      }
    }
  }
}
</style>